import React from 'react';

import * as classes from './TotalsPanel.module.css';

const LookupTotals = ({
    title,
    value,
    ...props
}) => {

    return (
        <div className={classes.TotalsPanel}>
            <div className={classes.EntityContainer}>
                <div>
                    <p className={classes.Title}>{title}</p>
                    <p className={classes.Value}>{value}</p>
                </div>
            </div>
        </div>
    );
};

export default LookupTotals;
